var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooerSectionTwitterBgBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.57041 5.50461L12.3059 0L11.1837 0L7.07191 4.77958L3.78782 0L0 0L4.9662 7.22757L0 13H1.12222L5.46441 7.9526L8.93265 13H12.7205L7.57013 5.50461H7.57041ZM6.03337 7.29124L5.53019 6.57154L1.52657 0.844787H3.25024L6.48121 5.46646L6.98439 6.18616L11.1843 12.1936H9.46059L6.03337 7.29152V7.29124Z",
    fill: "#1D1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooerSectionTwitterBgBlack);
export default __webpack_public_path__ + "static/media/fooer_section_twitter_bg_black.8e9139d8b2151958cef2fa3762653203.svg";
export { ForwardRef as ReactComponent };